import React from 'react';

export const TopicBadge: React.FC<{ name: string }> = ({ name }) => (
  <span className="text-[12px] font-medium text-mb-charcoal">{name}</span>
);
